import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { Notify, Loading } from 'quasar'

// API's
import account from "@/api/account/auth.api";

const baseURL = process.env.VUE_APP_PROMOTORES

const http = axios.create({ baseURL })

http.interceptors.request.use((config) => {
    Loading.show()

    // Check If the user is logged in.
    if (store.get('auth/is_logged_in')) {
        config.headers['Authorization'] = `Bearer ${store.get('auth/token')}`
    }

    return config
});

http.interceptors.response.use(
    ({ data }) => {
        Loading.hide()
        return data
    }, 
    (error, r) => {
        Loading.hide()
        if (error.response && error.response.status == 401 && error.response.data && error.response.data.error && error.response.data.error == 'Expired token') {
            if (store.get('auth/refresh')) {
                let token = store.get('auth/refresh')
    
                return account.refresh(token)
                .then(({ token, exp }) => {
                    if (token) {
                        store.commit('auth/token', token)
                        store.commit('auth/exp', exp)
    
                        error.config.headers.Authorization = 'Bearer '+token;
                        return http.request(error.config);
                    }else {
                        return Promise.reject(error);
                    }
                })
            }
        }

        // Check If the user is unauthorized.
        if (error.response.status === 401) {
            router.push({ name: 'login' })
            return
        }
 
        if (error.response.data.code === 'model_not_found' && error.response.data.model !== 'usuario') {
            return Promise.reject(error)
        }

        if (error.response.data.code === 'unprocessable_entity') {
            Notify.create({
                type: 'negative',
                position: 'bottom',
                message: error.response.data.errors.join('<br>'),
                progress: true,
                html: true
            })
        }

        if (error.response.data.message) {
            Notify.create({
                type: 'negative',
                position: 'bottom',
                message: error.response.data.message,
                progress: true
            })
        }

        return Promise.reject(error)
    }
)

export default http;